import { render, staticRenderFns } from "./VboxSimulate.vue?vue&type=template&id=0f5880ad&scoped=true&"
import script from "./VboxSimulate.vue?vue&type=script&lang=js&"
export * from "./VboxSimulate.vue?vue&type=script&lang=js&"
import style0 from "./VboxSimulate.vue?vue&type=style&index=0&id=0f5880ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5880ad",
  null
  
)

export default component.exports